import { IRuntime, IRuntimeSettings, IWidgetRendererFactory } from '../interfaces'

export async function createRuntime(
  rendererFactory: IWidgetRendererFactory,
  settings: IRuntimeSettings,
): Promise<IRuntime> {
  if (PREVIEW) {
    const PreviewRuntime = await import(/* webpackChunkName: "runtime-preview" */ './runtime.preview').then(
      module => module.PreviewRuntime,
    )
    return new PreviewRuntime(rendererFactory, settings)
  } else {
    const WidgetRuntime = await import(/* webpackChunkName: "runtime-general" */ './runtime').then(
      module => module.WidgetRuntime,
    )
    return new WidgetRuntime(rendererFactory, settings)
  }
}
